(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["custom-collection-product-grid"] && !Shopify.designMode) return;
  try {
    
  function initLoadMore(section) {
    const button = section.querySelector('.load-more-btn');
    if (!button) return;

    button.addEventListener('click', function () {
      const container = section.querySelector('.product-grid');
      const products = container.querySelectorAll('.product-item.is-hidden');
      const loadCount = parseInt(container.dataset.productsPerLoad, 10) || 8;

      for (let i = 0; i < loadCount && i < products.length; i++) {
        products[i].classList.remove('is-hidden');
      }

      if (container.querySelectorAll('.product-item.is-hidden').length === 0) {
        button.style.display = 'none';
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[id^="shopify-section-"]').forEach(function(section){
      initLoadMore(section);
    });
  });

  document.addEventListener('shopify:section:load', function (event) {
    initLoadMore(event.target);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-collection-product-grid_1"] && !Shopify.designMode) return;
  try {
    
  function initLoadMore(section) {
    const button = section.querySelector('.load-more-btn');
    if (!button) return;

    button.addEventListener('click', function (e) {
      // ✅ Scroll hone se roko
      e.preventDefault();

      const container = section.querySelector('.remaining-products');
      if (!container) return;

      const hiddenProducts = container.querySelectorAll('.product-item.is-hidden');

      let loadCount = parseInt(container.dataset.productsPerLoad);
      if (isNaN(loadCount)) loadCount = 4;

      for (let i = 0; i < loadCount && i < hiddenProducts.length; i++) {
        hiddenProducts[i].classList.remove('is-hidden');
      }

      // ✅ Agar sab aa gaye toh button hide
      if (container.querySelectorAll('.product-item.is-hidden').length === 0) {
        button.style.display = 'none';
      }
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[id^="shopify-section-"]').forEach(function (section) {
      initLoadMore(section);
    });
  });

  document.addEventListener('shopify:section:load', function (event) {
    initLoadMore(event.target);
  });

  } catch(e) { console.error(e); }
})();
})();
